module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "foreword",
      "id": "_idContainer000",
      "role": "doc-foreword"
    }
  }, [_c('p', {
    staticClass: "pl-fl-header"
  }, [_c('b', [_vm._v("“Don’t you want to teach?”")])]), _vm._v(" "), _c('p', {
    staticClass: "fl-fl-roman"
  }, [_vm._v("The vague feeling of discontent she’d been ignoring welled up inside her. “I certainly enjoy it. However, to be honest, it isn’t really what I want to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "fl-fl-roman"
  }, [_vm._v("He frowned. “Then what "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("do ")]), _vm._v("you want to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "fl-fl-roman"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I want to have a family with a husband and children of my own.")])]), _vm._v(" "), _c('p', {
    staticClass: "fl-fl-roman"
  }, [_vm._v("“Helen?” Quinn’s use of her Christian name for the first time drew her full attention. “I need to talk to you. I know this probably isn’t the right time, but I can’t hold it in.”")]), _vm._v(" "), _c('p', {
    staticClass: "fl-fl-roman"
  }, [_vm._v("“This sounds serious. Go ahead and tell me.”")]), _vm._v(" "), _c('p', {
    staticClass: "fl-fl-roman"
  }, [_vm._v("“My eldest nephew and niece are always going on about you and I’ve noticed that you seem to care a whole lot about them, too. That’s true, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "fl-fl-roman"
  }, [_vm._v("“It certainly is.”")]), _vm._v(" "), _c('p', {
    staticClass: "fl-fl-roman"
  }, [_vm._v("“Well, I’m doing my best for them, but anyone can tell that isn’t good enough.” He waved away her protests. “Now, that’s just the plain truth and you know it. The fact is that they need a mother.” She stared at him, wondering where this conversation was going before he spoke again. “I was wondering if you’d be willing to marry me—for the children’s sake.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d1163e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Introduction.vue
// module id = 57
// module chunks = 0